import { render, staticRenderFns } from "./customBanner.vue?vue&type=template&id=6c8eb40d&scoped=true"
import script from "./customBanner.vue?vue&type=script&lang=js"
export * from "./customBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8eb40d",
  null
  
)

export default component.exports